import _ from 'lodash';
import { useEffect, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { showMessage } from '~/helper';
import api from '~/services/api';
import useGlobalContext from './use-global-context';
import useHeader from './use-header';

const initialState = {
  loading: false,
  selecteds: [],
  model: {},
  showSupplierModal: false,
  modalData: {}
};

function useEventCreateOrUpdate() {
  const { id } = useParams(),
    history = useHistory(),
    { actions: headerActions } = useHeader(),
    { state: { eventCreateOrUpdate = initialState }, dispatch } = useGlobalContext();


  const load = useCallback(() => {
    api.get('events/load', { params: { id } }).then(response => {
      let model = response.data,
        selecteds = _.map(_.get(model, 'suppliers'), 'company.id');
      model.suppliers = model.suppliers || [];
      dispatch({type: 'eventCreateOrUpdate', payload: { model, selecteds }});
    });
  }, [dispatch, id]);

 useEffect(() => { load() }, [load]);

  useEffect(() => {
    headerActions.configure({
      title: id === 'new' ? `Novo evento` : `Evento (#${id})`,
      loading: _.get(eventCreateOrUpdate, 'loading', false),
    });
    // eslint-disable-next-line
  }, [eventCreateOrUpdate]);

  const failure = (error) => {
    dispatch({ type: 'eventCreateOrUpdate', payload: { loading: false }});
    showMessage('error', error);
  };

  const listPlaces = async (term, callback) => {
    try {
      const response = await api.get(`events/list-places`, { params: { term } });
      callback(response.data);
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const listEventsTypes = async (term, callback) => {
    try {
      const response = await api.get(`events/list-events-types`, { params: { term } });
      callback(response.data);
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const listSuppliers = async (term, callback) => {
    try {
      const response = await api.get(`events/list-suppliers`, { params: { term } });
      callback(response.data);
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const listUsers = async (term, callback) => {
    try {
      const response = await api.get(`events/list-users`, { params: { term } });
      callback(response.data);
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const iterator = (r) => _.get(r, 'company.id') || _.get(r, 'id');

  const selectSuppliers = async (selection, values) => {
    let params = _.cloneDeep(values),
      toAdd = _.differenceBy(selection, params.suppliers, iterator),
      toRemove = _.differenceBy(params.suppliers, selection, iterator);

    params.suppliers = params.suppliers || [];
    params.suppliersToRemove = params.suppliersToRemove || [];
    _.each(toRemove, (row) => {
      if (row.id) {
        params.suppliersToRemove.push(row);
      }
      _.remove(params.suppliers, (r) => _.get(r, 'company.id') === _.get(row, 'company.id'));
    });

    _.each(toAdd, (company) => {
      let data = _.find(params.suppliersToRemove, (r) => _.get(r, 'company.id') === company.id) || { company };
      if (data.id) {
        _.remove(params.suppliersToRemove, data);
      }
      params.suppliers.push(data);
    });
    let selecteds = _.map(params.suppliers, 'company.id');
    dispatch({ type: 'eventCreateOrUpdate', payload: { selecteds, model: params }});
  };

  const createOrUpdate = async (values) => {
    try {
      let params = { ...eventCreateOrUpdate.model, ...values };
    
      dispatch({ type: 'eventCreateOrUpdate', payload: { loading: true } });

      let editing = !!(params && params.id),
        method = editing ? 'put' : 'post',
        path = editing ? 'update' : 'create';

      await api[method](`events/${path}`, params);

      showMessage('success', `Fornecedor ${editing ? 'atualizado' : 'criado'} com sucesso`);

      history.push(`/events`);
    } catch (error) {
      failure(error);
    }
  };

  const openSupplierModal = () => {
    dispatch({ type: 'eventCreateOrUpdate', payload: { showSupplierModal: true, modalData: {} }});
  };

  const closeSupplierModal = () => {
    dispatch({ type: 'eventCreateOrUpdate', payload: { showSupplierModal: false, modalData: {} }});
  };

  const submitNewSupplier = async (values) => {
    let params = { eventId: id, companyId: _.get(values, 'supplier.id') };

    try {
      dispatch({ type: 'eventCreateOrUpdate', payload: { modalLoading: true } });
      await api.post(`events/add-supplier`, params);
      dispatch({ type: 'eventCreateOrUpdate', payload: { showSupplierModal: false, modalLoading: false, modalData: {} } });
      load();
      showMessage('success', `Email enviado com sucesso!`);
    } catch (error) {
      failure(error);
    }
  };

  return {
    state: {
      ...eventCreateOrUpdate,
      loading: !eventCreateOrUpdate.model
    },
    actions: {
      listPlaces,
      listEventsTypes,
      listSuppliers,
      listUsers,
      selectSuppliers,
      createOrUpdate,
      openSupplierModal,
      submitNewSupplier,
      closeSupplierModal,
    }
  }
}

export default useEventCreateOrUpdate;